import React, { FC, useEffect, useState } from 'react';
import { destroyStack, getPullRequestWithStacksMerge, planSandbox } from '../api/requests';
import { useNavigate } from 'react-router-dom';
import { PullRequest } from '../models/PullRequest';
import { useAuthUser } from '../containers/AuthProvider';
import { Trash } from '@emotion-icons/ionicons-outline/Trash';
import { Refresh } from '@emotion-icons/ionicons-outline/Refresh';
import { LogoGithub } from '@emotion-icons/ionicons-solid/LogoGithub';
import styled from '@emotion/styled';
import { extractStackShortId } from '../api/utils/utils';

const SandboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  justify-content: center;
`;

const CircleButton = styled.button`
  background-color: ${(props) => props.color};
  border-radius: 2rem;
  border: 0;
  padding: 0.5rem;
  color: white;
  cursor: pointer;
`;

const Button = styled.button`
  background-color: blue;
  border-radius: 1rem;
  border: 0;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  max-width: 8rem;
  color: white;
  cursor: pointer;
`;

const TRContainer = styled.tr`
  &:hover {
    background-color: #F7F9FC;
  }
`;

const TDContainer = styled.td`
  padding: 1rem;
`;

const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: .5rem;
`;

const TDGithubContainer = styled(TDContainer)`
  display: flex;
  justify-content: center;
`;

const GithubIcon = styled(LogoGithub)`
  color: black;
`;

export const PullRequestPage: FC = () => {
  const [pullRequests, setPullRequests] = useState<PullRequest[]>([]);
  const navigate = useNavigate();
  const user = useAuthUser();

  useEffect(() => {
    const fetchData = async () => {
      const newPullRequest = await getPullRequestWithStacksMerge();
      setPullRequests(newPullRequest);
    };

    fetchData().catch(console.error);
  }, []);

  const handlePlanSandbox = (branchName: string, repo: string, pullRequestNumber: string, idModifier: number) => async () => {
    await planSandbox(branchName, user?.email || 'web-actor-not-defined', repo, pullRequestNumber, idModifier);
    navigate('/');
  };

  const handleDestroyStack = (stackName: string) => async () => {
    const stackId = extractStackShortId(stackName);
    await destroyStack(stackId, user?.email || 'web-actor-not-defined');
    navigate('/');
  };

  return <div>
    <table>
      <thead>
        <tr>
          <th>Owner</th>
          <th>Project</th>
          <th>Title</th>
          <th>Branch</th>
          <th>GitHub Link</th>
          <th>Sandbox</th>
        </tr>
      </thead>
      <tbody>
        {pullRequests && pullRequests.map(pullRequest => <TRContainer key={pullRequest.id}>
          <TDContainer>{pullRequest.owner}</TDContainer>
          <TDContainer>{pullRequest.project}</TDContainer>
          <TDContainer>{pullRequest.title}</TDContainer>
          <TDContainer>{pullRequest.branchName}</TDContainer>
          <TDGithubContainer><a href={pullRequest.url} rel="noreferrer" target="_blank"><GithubIcon size={40}/></a></TDGithubContainer>
          <TDContainer>
            <SandboxContainer>
              <Button onClick={handlePlanSandbox(pullRequest.branchName, pullRequest.repo, pullRequest.number, pullRequest.nextNewIdModifier)}>Plan</Button>
              {pullRequest.zzmExistingSandboxes?.map(stack =>
                <ActionsContainer>
                  {extractStackShortId(stack.stackName)}
                  <CircleButton
                    color={stack.isUpdating ? 'gray' : 'green'}
                    disabled={stack.isUpdating}
                    onClick={handlePlanSandbox(pullRequest.branchName, pullRequest.repo, pullRequest.number, stack.idModifier)}
                  >
                    <Refresh size={24}/>
                  </CircleButton>
                  <CircleButton
                    color={stack.isDeleting ? 'gray' : 'red'}
                    disabled={stack.isDeleting}
                    onClick={handleDestroyStack(stack.stackName)}
                  >
                    <Trash size={24}/>
                  </CircleButton>
                </ActionsContainer>)}
              </SandboxContainer>
          </TDContainer>
        </TRContainer>)}
      </tbody>
    </table>
  </div>;
};
